import { Tooltip, TooltipContent, TooltipTrigger } from '@optools/components/ui/tooltip';
import { MilestoneType } from '@optools/services/operator-gateway/types/generated/graphql';
import { TriangleAlert } from 'lucide-react';

import { useMilestoneEditor } from '../context/milestone-editor-context';
import {
  shouldDisplayStreamStartWarning,
  shouldDisplayStreamStopWarning,
} from '../utils/milestones';

const WarningTooltip = ({ text }: { text: string }) => {
  return (
    <Tooltip>
      <TooltipTrigger>
        <TriangleAlert className="size-4 stroke-amber-400" />
      </TooltipTrigger>
      <TooltipContent className="text-xs">{text}</TooltipContent>
    </Tooltip>
  );
};

export function StreamStartWarningTooltip({
  absoluteTime,
  milestoneType,
}: {
  absoluteTime: string;
  milestoneType: MilestoneType;
}) {
  const { programDateTime } = useMilestoneEditor();
  const displayStreamStartWarning = shouldDisplayStreamStartWarning(
    milestoneType,
    programDateTime,
    absoluteTime,
  );

  return displayStreamStartWarning ? (
    <WarningTooltip text="Stream Start Time does not match Program Date Time" />
  ) : null;
}

export function StreamStopWarningTooltip({
  milestoneType,
  videoTime,
}: {
  milestoneType: MilestoneType;
  videoTime: number;
}) {
  // We need to parse duration from context so that the milestone table does not rerender when the video duration updates during live games
  const { duration, programDateTime } = useMilestoneEditor();
  const displayStreamStopWarning = shouldDisplayStreamStopWarning(
    milestoneType,
    programDateTime,
    duration,
    videoTime,
  );

  return displayStreamStopWarning ? (
    <WarningTooltip text="Stream Stop Time does not match the end time of the video" />
  ) : null;
}
